'use client';

import { useContext } from 'react';

import { CommunityContext, type CommunityContextValue } from './context';

export function useCommunityContext(): CommunityContextValue {
  const ctx = useContext(CommunityContext);
  if (!ctx) {
    throw new Error(
      'useCommunityContext must be used within a CommunityProvider',
    );
  }
  return ctx;
}
